<template>
  <div :id="uppyId">
    <div id="ThumbnailContainer">
      <v-btn icon id="UppyModal">
        <v-icon large>cloud_upload</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Core, Dashboard, XHRUpload } from 'uppy'
import { TokenService } from '@/services/token.service'

export default {
  name: 'Uppy',
  props: {
    modelClass: {
      type: String,
      required: true
    },
    modelId: {
      type: Number,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {
    uppyId() {
      return this.modelClass + '-' + this.modelId
    }
  },

  mounted() {
    const uppy = Core({
      id: this.uppyId,
      debug: true,
      autoProceed: true,
      allowMultipleUploads: true,
      limit: 2,
      restrictions: {
        maxFileSize: 1000 * 1000 * 5, // 5MB
        allowedFileTypes: ['image/jpeg', 'image/png']
      },
      meta: {
        modelClass: this.modelClass,
        modelId: this.modelId
      },
      onBeforeFileAdded: () => {
        console.log('onBeforeFileAdded...')
      },
      onBeforeUpload: () => {
        console.log('onBeforeUpload...')
      }
    })

    // uppy.use(Webcam)

    uppy.use(Dashboard, {
      trigger: '#UppyModal',
      // plugins: ['Webcam'],
      height: 100,
      proudlyDisplayPoweredByUppy: false,
      showSelectedFiles: true,
      showLinkToFileUploadResult: false,
      showProgressDetails: true,
      hideRetryButton: true,
      hidePauseResumeButton: true,
      closeModalOnClickOutside: true,
      closeAfterFinish: false,
      metaFields: [
        {
          id: 'title',
          name: 'Title',
          placeholder: 'Title of the photograph'
        }
      ]
    })

    uppy.use(XHRUpload, {
      endpoint: this.endpoint,
      fieldName: 'images',
      //   bundle: true,
      headers: {
        Authorization: 'Bearer ' + TokenService.getToken(),
        'X-CSRF-TOKEN': window.csrfToken
      }
    })

    uppy.on('upload-success', (file, response) => {
      //   console.log('upload success')
      //   console.log(file)
      //   console.log(response.status)
      //   console.table(response.body)
      response.body.forEach(image => {
        if (image.error) {
          uppy.info(
            {
              message: 'Failed to upload image: ' + file.name,
              details: image.error
            },
            'error',
            5000
          )
          uppy.removeFile(file.id)
        } else {
          this.$emit('imageUploadSuccess', image)
        }
      })
    })
  },

  methods: {}
}
</script>

<style src="uppy/dist/uppy.min.css"></style>
